import { QueryClient } from '@tanstack/react-query'
import { captureException } from '../config/sentry'

// Create a query client with Sentry error tracking
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        if (error instanceof Error) {
          const message = error.message
          if (message.includes('400') || message.includes('401') || 
              message.includes('403') || message.includes('404')) {
            return false
          }
        }
        // Retry up to 3 times for other errors
        return failureCount < 3
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false, // Disable automatic refetch on window focus
      refetchOnReconnect: 'always', // Refetch when reconnecting
    },
    mutations: {
      retry: false, // Don't retry mutations by default
    },
  },
})

// Global error handler for React Query
queryClient.getQueryCache().config.onError = (error) => {
  // Log query errors to Sentry
  if (error instanceof Error) {
    captureException(error, {
      tags: {
        source: 'react-query',
        type: 'query',
      },
    })
  }
}

queryClient.getMutationCache().config.onError = (error) => {
  // Log mutation errors to Sentry
  if (error instanceof Error) {
    captureException(error, {
      tags: {
        source: 'react-query',
        type: 'mutation',
      },
    })
  }
}